<template>
  <section>
    <h1>❌ Seite nicht gefunden</h1>
    <p>Diese Seite existiert nicht. Bitte prüfe die URL.</p>
  </section>
</template>
